import { api_configs } from "src/api-services";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getDesignation = createAsyncThunk(
    'designationdata/getDesignation',
    async (payload) => {
        try {
            // Simulating async operation, returning dummy data after a delay
            const res = await axios({
                method: "GET",
                url: api_configs.desigantionList,
                headers: {
                    token: window.localStorage.getItem("token")
                }
            });
            if (res.data.responseCode === 200) {
                return res.data.result.docs;
            }
            // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulating delay
            // return cardDetails.data; // Return dummy data directly
        } catch (error) {
            throw error; // Let the rejection handle in createSlice catch this
        }
    }
);

// Slice for products
const designationSlice = createSlice({
    name: 'designationdata',
    initialState: { isLoading: false, designation: [], error: null },
    extraReducers: (builder) => {
        builder
            .addCase(getDesignation.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getDesignation.fulfilled, (state, action) => {
                state.isLoading = false;
                state.designation = action.payload;
                state.error = null;
            })
            .addCase(getDesignation.rejected, (state, action) => {
                state.isLoading = false;
                state.designation = [];
                state.error = action.error.message; // Access error message
            });
    },
});



// Selectors to access state from Redux store
export const selectDesignation = (state) => state.designationdata.designation;

// Exporting reducers
export default designationSlice.reducer;